import { initializeApp } from "firebase/app";

import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSF_hRqH6MAPwVsLwA28pHwNN-48IWNAA",
  authDomain: "z-store-a82cc.firebaseapp.com",
  projectId: "z-store-a82cc",
  storageBucket: "z-store-a82cc.firebasestorage.app",
  messagingSenderId: "526320647623",
  appId: "1:526320647623:web:1bb529bc1c23d0aa252de2",
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, RecaptchaVerifier, signInWithPhoneNumber };
